import React, { Component, PropTypes, PureComponent } from 'react';
import fetchMock from 'fetch-mock';
// import makeRequest from '../../api/pages';
import homePage from '../../data/homePage.json'

export default class Description extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      picture: "",
      content: "",
      motto: ""
    };
  }

  componentDidMount() {
    // this.load();
    var value = typeof source === "string" ? JSON.parse(homePage) : homePage;
    this.setState({ name: value[0].name, picture: value[0].picture, content: value[0].content, motto: value[0].motto })
  }

  render() {

    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <h3>{this.state.name}</h3>

          </div>
        </div>

        <div className="row">
        <div className="col-sm-6 text-justify item">
            <p>{this.state.content}</p>
            <h3 className="text-center">{this.state.motto} </h3>
          </div>
          <div className="col-sm-6 text-center item">
           <img src={this.state.picture} />
          </div>

        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./app/screens/About/description.js